//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { InfographicEditStyles } from "@/utils/dto/profile.js";
import TheImage from "@/components/objects/TheImage.vue";
import ColorChoice from "@/components/objects/choices/ColorChoice.vue";
import BorderChoice from "@/components/objects/choices/BorderChoice.vue";
import LineWidthChoice from "@/components/objects/choices/LineWidthChoice.vue";
// import ShadowChoice from "@/components/objects/choices/ShadowChoice.vue";
import BackgroundChoice from "@/components/objects/choices/BackgroundChoice.vue";
import OpacityChoice from "@/components/objects/choices/OpacityChoice.vue";
import LogoSizeChoice from "@/components/objects/choices/LogoSizeChoice.vue";
import FontSizeChoice from "@/components/objects/choices/FontSizeChoice.vue";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import cloneDeep from "lodash/cloneDeep"
import { SHADOW_OPTIONS, LINE_WIDTH, BORDERS, AUTHOR_FONT_SIZE, NAME_FONT_SIZE } from "@/constants/ui.js";

export default {
  name: "InfographicStyleEditor",

  components: { TheImage, ColorChoice, BorderChoice, LineWidthChoice, BackgroundChoice, OpacityChoice, LogoSizeChoice, FontSizeChoice, TheSwitch },

  props: {
    value: {
      type: [InfographicEditStyles, Object],
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      borderStylesVisible: false,
      visible: false,
      editStyleForm: null,
      styles: cloneDeep(this.value) ?? new InfographicEditStyles(),
      bgGeneralStoreParams: {
        // uploaded_file_id: id,
        model: 'user',
        model_id:  this.$auth?.user?.id ?? this.$auth?.user?.username ?? this.$auth?.user?.profile?.nickname,
        path: `profile_form.infographic_styles.${this.index}.styles.background.bgID`
      },
      nameGeneralStoreParams: {
        // uploaded_file_id: id,
        model: 'user',
        model_id:  this.$auth?.user?.id ?? this.$auth?.user?.username ?? this.$auth?.user?.profile?.nickname,
        path: `profile_form.infographic_styles.${this.index}.styles.nameAndLogo.bgID`
      },
    }
  },
  computed: {
    shadowOptions() {
      return SHADOW_OPTIONS
    },
    borders() {
      return BORDERS
    },
    lineWidth() {
      return LINE_WIDTH
    },
    AUTHOR_FONT_SIZE() {
      return AUTHOR_FONT_SIZE
    },
    NAME_FONT_SIZE() {
      return NAME_FONT_SIZE
    },
    isPermit() {
      return this.$auth?.loggedIn && this.$auth?.user?.profile?.use_own_style
    },
  },
  watch: {
    styles: {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          this.$emit('edit', this.styles)
        }
      },
      deep: true
    },
    value: {
      handler() {
        if (this.value) {
          this.styles = cloneDeep(this.value)
        } else {
          this.styles = new InfographicEditStyles()
        }
      },
      deep: true
    },
  },
  methods: {
    updateValue(data) {
      this.$emit('updateValue', data)
    },
    resetEditStyle() {
      this.styles = new InfographicEditStyles()
      this.$emit('edit', this.styles)
    },
  },
}
